import { pushTimeData } from "../dataLayer/v1Export";
import { TimeEntryData } from "../interfaces/V1Interface";

class V1ExportManager {

    // Method to push approved time entries back to V1
    async exportV1Data(timesPayload: { times: TimeEntryData[] }): Promise<any> {
        try {
            // Call the data layer function to push the export data to V1
            const authData = await pushTimeData(timesPayload);
            console.log("Export successful:", authData);
            
            // Return the fetched data
            return authData;

        } catch (error) {
            // Log and re-throw any error that occurs during the fetch process
            console.error("Error during exporting data:", error);
            throw error;
        }
    }

}

// Exporting an instance of V1ExportManager to use throughout the application
export default new V1ExportManager();
